<template>
<div id="secure">
    <NewTopMenu />
    <div class="container">
        <div class="columns">
            <div class="column is-3"><button class="button is-medium is-fullwidth" v-on:click="goManageClasses()">Classes/Departments &amp; Users</button></div>
            <div class="column is-3"><button class="button is-medium is-fullwidth" v-on:click="goManageTeachers()">Teachers/Supervisors</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth is-primary">Items</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageNotifications()">Notifications</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageGroups()">Groups</button></div>
            <!-- <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageBadges()">Badges</button></div> -->
        </div>
        
        <div class="columns">
            <div class="column is-12">
                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Items</p>
                        <!-- <a class="button is-primary" v-on:click="addContentSources()" style="margin: 5px;" v-show="!displayItemSources">Add An Item</a>
                        <a class="button is-warning" v-on:click="closeAddContentSources()" style="margin: 5px" v-show="displayItemSources">Close Add Item</a> -->
                        <!-- <a class="button is-primary" v-on:click="addContentForm()" style="margin: 5px;" v-show="!addContent">Add An Item</a>
                        <a class="button is-warning" v-on:click="closeAddContentForm()" style="margin: 5px" v-show="addContent">Close Add Item</a> -->
                        <b-button type="is-primary" v-on:click="goViewTemplates()" v-show="displayAddFromTemplateButton" style="margin: 5px;">Create New Items</b-button>
                        <b-button type="is-info is-light" v-on:click="goManageBehaviorTags()" style="margin: 5px;">Manage Categories</b-button>
                    </div>
                    <div class="card-content">
                        <!-- <div class="content" v-show="displayItemSources">
                            <div class="columns">
                                <div class="column is-4"><b-button type="is-primary is-fullwidth" v-on:click="goViewTemplates()" v-show="displayAddFromTemplateButton">Add from template</b-button></div>
                                <div class="column is-4"><b-button type="is-info is-fullwidth" v-show="displaySelectFromListButton">Select from list</b-button></div>
                                <div class="column is-4"><b-button type="is-warning is-fullwidth" v-on:click="displayHideContentForm()">{{ createFromScratchLabel }}</b-button></div>
                            </div>
                        </div> -->
                        <b-message title="Guide: Item type" type="is-success" aria-close-label="Close message" class="notification-tutorial">
                            a) Normal (General use such as Help teachers, consult supervisor, clean class/office etc)<br/>
                            b) Attendance (Daily Attendance. Max 1x daily. Usually used when users clock in schools/office). View monthly attendance from Home > Attendance > Class, choose month, view monthly attendance.<Br/>
                            c) Subject attendance (Attendance for each subject class or meetings. No max daily scan. View monthly attendance from Home> Attendance > Class, choose month, view monthly attendance> Choose list of class from top right panel.<br/>
                            d) Parents (Help parents, obey parents, do homework, sleep early etc). Submitted by parents/students via Parents app. Parent login from their ID submitted to the system. It can be ID, phone number or email<br/><br/>
                            *No idea what to create? <a v-on:click="goExternalPage()">View list here</a> 
                        </b-message>
                        <div class="content">
                            <add-content></add-content>
                        </div>
                        <loading :active.sync="isLoading" 
                            :can-cancel="false" 
                            :is-full-page="true">
                        </loading>
                        <!-- <data-list v-bind:dataList="dataList" class="columns is-multiline"></data-list> -->
                        <data-list v-bind:dataList="dataList"></data-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./../../NewTopMenu";
import AddContent from './AddContent';
import DataList from './DataList';
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

// sambung sini imin, buat bole pilih items dgn categories tu
export default {
    name: "ManageBehaviorsHome",
    components: {
        NewTopMenu,
        Loading,
        AddContent,
        DataList
    },
    data() {
        return {
            data : {
                repeatOn : []
            },
            schoolPlan: 0,
            dataList: [],
            input: { },
            isLoading: false,
            displayItemSources: true,
            addContent: false,
            createFromScratchLabel: "Create from scratch",
            displayAddFromTemplateButton: true,
            displaySelectFromListButton: true
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
        console.log("before mount hoho");
        this.getData()
    },
    methods: {
        goExternalPage(){
            window.open("https://www.studentqr.com/list-of-behavior", '_blank');
        },
        addContentSources(){
            this.displayItemSources = true;
        },
        closeAddContentSources(){
            this.displayItemSources = false;
        },
        displayHideContentForm(){
            if (this.addContent == false){
                this.addContent = true;
                this.createFromScratchLabel = "Close create from scratch"
            }else{
                this.addContent = false;
                this.createFromScratchLabel = "Create from scratch"
            }
        },
        closeAddContentForm(){
            this.addContent = false;
            this.createFromScratchLabel = "Create from scratch"
        },
        getData(){
            let self = this;
            self.isLoading = true;

            console.log("124 url: " + process.env.NEW_ENDPOINT + '/behaviors/list/')
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                except: 3
            })
            .then(response => {
                self.dataList = response.data
                self.isLoading = false
                // console.log("133 mee")
                // console.log(self.dataList)
            })
            .catch(e => {
                console.log(e)
                self.isLoading = false
            })
        },
        goManageClasses(){
            this.$router.push({
                name: "ManageClassesHome"
            });
        },
        goManageStudents(){
            this.$router.push({
                name: "ManageStudentsHome"
            });
        },
        goManageTeachers(){
            this.$router.push({
                name: "ManageTeachersHome"
            });
        },
        goManageNotifications(){
            this.$router.push({
                name: "ManageNotificationsHome"
            });
        },   
        goManageGroups(){
            this.$router.push({
                name: "ManageGroupsHome"
            });
        },
        goManageBadges(){
            this.$router.push({
                name: "ManageBadgesHome"
            });
        },
        goManageBehaviorTags(){
            this.$router.push({
                name: "ManageBehaviorsTagsHome"
            });
        },
        goViewTemplates(){
            this.$router.push({
                name: "ManageBehaviorsTemplates"
            });
        },
    },    
    created() {
        this.schoolID = localStorage.getItem('schoolID');
        console.log("182 schoolID: " + this.schoolID)
        this.schoolPlan = localStorage.getItem('plan')

        if ((this.schoolPlan == 1) || (this.schoolPlan == 2)){
            this.displayAddFromTemplateButton = true
            this.displaySelectFromListButton = true
        }else{
            this.displayAddFromTemplateButton = false
            this.displaySelectFromListButton = false
        }
        console.log("190 schoolPlan: " + this.schoolPlan)
    },
    mounted(){
    },
};
</script>

<style scoped>
.container{
    padding: 10px;
}
.box{
    border: 1px solid #ccc;
    width: 40% !important;
    margin: 4px;
    padding: 0px !important;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
</style>



// WEBPACK FOOTER //
// src/components/Manage/Behaviors/Home2.vue